import { Flex, Switch } from "@chakra-ui/react";
import { useIntl } from "react-intl";

import { AssetState, ModelCompact } from "__graphql__/types";
import { BatteryIcon } from "ui/Icons/Icons";
import { BodyM } from "ui/Typography/Typography";

export function BatteryScannedCard({
  state,
  model,
  serialNumber,
  isHighlighted = false,
  onToggle,
  isToggling = false,
}: {
  state: AssetState;
  model?: ModelCompact;
  serialNumber: string;
  isHighlighted?: boolean;
  onToggle?: () => void;
  isToggling?: boolean;
}) {
  const intl = useIntl();
  const isOperational = state === AssetState.asset_state_operational;

  return (
    <Flex
      p="s200"
      direction="column"
      gap="s200"
      borderRadius="sm"
      bg="white"
      outline={isHighlighted ? "1px solid" : "none"}
      outlineColor={isHighlighted ? "pinkFlink.500" : "transparent"}
      outlineOffset={0}
      transition="outline .3s ease"
    >
      <Flex gap="s100">
        <BatteryIcon boxSize="24px" />
        <BodyM noOfLines={1} wordBreak="break-all">
          <strong>{model?.name}</strong> {serialNumber}
        </BodyM>
      </Flex>
      <Flex alignItems="center" gap="s100">
        <Switch
          variant="positiveNegative"
          size="md"
          isChecked={isOperational}
          isDisabled={isToggling}
          onChange={onToggle}
        />
        <BodyM>{intl.formatMessage({ id: "pages.inventory.battery-details-page.switch" })}</BodyM>
      </Flex>
    </Flex>
  );
}
